module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showEvaluation) ? _c('evaluationModal', {
    on: {
      "closeModal": _vm.closeEvaluation,
      "submitData": _vm.submitEvaluation
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "secTop"
    }
  }, [_c('personal', {
    attrs: {
      "info": _vm.caseInfo,
      "keys": 100
    }
  }), _vm._v(" "), (_vm.showOrder) ? _c('orderModal', {
    attrs: {
      "caseTrans": _vm.caseInfo,
      "caseId": _vm.$route.params.id
    },
    on: {
      "close": _vm.closeOrder
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "operate-area"
  }, [_c('mu-raised-button', {
    staticStyle: {
      "color": "#fff",
      "border-radius": "40px",
      "background-color": "#1bbe9f"
    },
    attrs: {
      "label": "现场测评"
    },
    on: {
      "click": _vm.openEvaluation
    }
  }), _vm._v(" "), _c('trainScene', {
    attrs: {
      "caseID": _vm.$route.params.id,
      "showFlag": 2
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bc36796!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/case/secondtop.vue
// module id = 959
// module chunks = 2